"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = void 0;
var constants_1 = require("./utils/constants");
function isNumber(source, checkSafetyNumber) {
    if (checkSafetyNumber === void 0) { checkSafetyNumber = false; }
    var isNumb = typeof source === 'number' && isFinite(source);
    if (isNumb && checkSafetyNumber)
        return source <= constants_1.MAX_SAFETY_NUMBER && source >= constants_1.MIN_SAFETY_NUMBER;
    return isNumb;
}
exports.isNumber = isNumber;
